import type { SVGProps } from "react"

export interface IconProps extends Omit<SVGProps<SVGSVGElement>, "size"> {
  size?: number
}

export const iconBaseProps = (size: number, props: SVGProps<SVGSVGElement>) => ({
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
})

export interface FillableIconProps extends IconProps {
  filled?: boolean
}
